import React, { useState, useEffect } from "react";
import { DrawerProps } from "@mui/material";
import BottomDrawer, { OnAddOrSave } from "../../common/BottomDrawer";
import { useTranslation } from "react-i18next";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { ElogParticipant } from "@services/meetings/types";
import Form from "./Form";
import { canHaveEmptyDialIn, isValidForm, withDefaultValues } from "./const";

const Container = (
  props: DrawerProps & {
    participant?: Partial<ElogParticipant>;
    onSave: (v: Partial<ElogParticipant>) => void;
    onClose: () => void;
  }
) => {
  const { t } = useTranslation();
  const { participant, onSave, onClose, ...drawerProps } = props;
  const isEdit = participant?.id !== undefined;
  const context = React.useContext(RoomsRealtimeContext);
  const meeting = context.detail?.meeting;
  const [form, setForm] = useState<Partial<ElogParticipant>>(
    withDefaultValues(participant, meeting)
  );
  const emptyDialOption = canHaveEmptyDialIn(participant);

  useEffect(() => {
    setForm(withDefaultValues(participant, meeting));
  }, [participant]);

  const saveActionProps: OnAddOrSave = isEdit
    ? { onSave: () => onSave(form) }
    : { onAdd: () => onSave(form) };
  return (
    <BottomDrawer
      title={t(isEdit ? "Edit E-Log" : "Add E-Log")}
      disabled={!isValidForm(form)}
      onClose={onClose}
      {...saveActionProps}
      {...drawerProps}
    >
      {props.open && (
        <Form
          participant={form}
          onChange={setForm}
          emptyDialOption={emptyDialOption}
        />
      )}
    </BottomDrawer>
  );
};

export default Container;
